'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateQuantitySelector = exports.QuantitySelector = exports.ACTIVE_SELECTORS = exports.PLUS_BUTTON = exports.MINUS_BUTTON = exports.FIELD = exports.WRAPPER = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _pcSlateTools = require('./../../process/pc-slate-tools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WRAPPER = exports.WRAPPER = '[data-quantity-selector]';
var FIELD = exports.FIELD = '[data-quantity-selector-field]';
var MINUS_BUTTON = exports.MINUS_BUTTON = '[data-quantity-selector-minus]';
var PLUS_BUTTON = exports.PLUS_BUTTON = '[data-quantity-selector-plus]';

var ACTIVE_SELECTORS = exports.ACTIVE_SELECTORS = [];

var QuantitySelector = exports.QuantitySelector = function () {
  function QuantitySelector(container) {
    (0, _classCallCheck3.default)(this, QuantitySelector);

    this.container = container;

    this.wrapper = container.find(WRAPPER);
    if (!this.wrapper.length) this.wrapper = this.container;

    //Elements
    this.minus = this.container.find(MINUS_BUTTON);
    this.input = this.container.find(FIELD);
    this.plus = this.container.find(PLUS_BUTTON);

    //Values
    this.min = this.wrapper.attr('data-min') || 0;
    this.max = this.wrapper.attr('data-max') || null;
    this.value = this.getSelectorValue();

    if (this.min == "null") this.min = null;
    if (this.max == "null") this.max = null;

    //Events
    this.attachEvents();
  }

  (0, _createClass3.default)(QuantitySelector, [{
    key: 'attachEvents',
    value: function attachEvents() {
      var _this = this;

      this.minusHandler = function (e) {
        return _this.onMinusClick(e);
      };
      this.plusHandler = function (e) {
        return _this.onPlusClick(e);
      };
      this.changeHandler = function (e) {
        return _this.onFieldChange(e);
      };

      this.cartPendingHandler = function () {
        return _this.onCartPending();
      };
      this.cartFinishedHandler = function () {
        return _this.onCartFinished();
      };

      this.container.on('click', MINUS_BUTTON, this.minusHandler);
      this.container.on('click', PLUS_BUTTON, this.plusHandler);
      this.container.on('change', FIELD, this.changeHandler);

      (0, _jquery2.default)(document).on(_pcSlateTools.ON_CART_PENDING, this.cartPendingHandler);
      (0, _jquery2.default)(document).on(_pcSlateTools.ON_CART_FINISHED, this.cartFinishedHandler);

      if (ACTIVE_SELECTORS.indexOf(this) === -1) ACTIVE_SELECTORS.push(this);
    }
  }, {
    key: 'detachEvents',
    value: function detachEvents() {
      this.container.off('click', MINUS_BUTTON, this.minusHandler);
      this.container.off('click', PLUS_BUTTON, this.plusHandler);
      this.container.off('change', FIELD, this.changeHandler);

      (0, _jquery2.default)(document).off(_pcSlateTools.ON_CART_PENDING, this.cartPendingHandler);
      (0, _jquery2.default)(document).off(_pcSlateTools.ON_CART_FINISHED, this.cartFinishedHandler);

      var i = ACTIVE_SELECTORS.indexOf(this);
      if (i !== -1) ACTIVE_SELECTORS.splice(i, 1);
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.value;
    }
  }, {
    key: 'getSelectorValue',
    value: function getSelectorValue() {
      var val = parseInt(this.input.val());
      if (isNaN(val) || !isFinite(val)) val = 1;
      return val;
    }
  }, {
    key: 'setMin',
    value: function setMin(min) {
      this.min = min;
      this.setValue(this.getValue());
    }
  }, {
    key: 'setMax',
    value: function setMax(max) {
      this.max = max;
      this.setValue(this.getValue());
    }
  }, {
    key: 'setValue',
    value: function setValue(value, fireEvent) {
      if ((typeof fireEvent === 'undefined' ? 'undefined' : (0, _typeof3.default)(fireEvent)) === (typeof undefined === 'undefined' ? 'undefined' : (0, _typeof3.default)(undefined))) fireEvent = true;
      //String checking
      value = '' + value;
      if (!value.replace(/\s/gi).length) value = this.getValue();
      if (!value.replace(/\s/gi).length) value = 1;

      value = parseInt(value);
      if (isNaN(value) || !isFinite(value)) value = 1;

      //Clamping
      if (this.max != null && value > this.max) value = this.max;
      if (this.min != null && value < this.min) value = this.min;

      //No need to update if current
      var current = this.getValue();

      this.value = value;

      //Due to an issue with jQuery we have to wait a frame before we can update
      //the input field to reflect the changes.
      if (this.getSelectorValue() != value) this.input.val('' + value);

      this.updateClasses();
      if (fireEvent && current != value) this.onQuantityChanged(value, current);
    }

    //Rendering

  }, {
    key: 'updateClasses',
    value: function updateClasses() {
      if (this.max != null && this.min != null && this.min >= this.max) {
        this.input.addClass('is-disabled');
        this.input.attr('disabled', 'disabled');
      } else {
        this.input.removeClass('is-disabled');
        this.input.removeAttr('disabled');
      }

      //Update Minus Button
      if (this.min != null && this.getValue() <= this.min) {
        this.minus.addClass('is-disabled');
        this.minus.attr('disabled', 'disabled');
      } else {
        this.minus.removeClass('is-disabled');
        this.minus.removeAttr('disabled');
      }

      //Update Plus Button
      if (this.max != null && this.getValue() >= this.max) {
        this.plus.addClass('is-disabled');
        this.plus.attr('disabled', 'disabled');
      } else {
        this.plus.removeClass('is-disabled');
        this.plus.removeAttr('disabled');
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.detachEvents();
    }

    //Events

  }, {
    key: 'onQuantityChanged',
    value: function onQuantityChanged(newQuantity, oldQuantity) {}
  }, {
    key: 'onQuantityPlus',
    value: function onQuantityPlus() {}
  }, {
    key: 'onQuantiyMinus',
    value: function onQuantiyMinus() {}
  }, {
    key: 'onFieldChange',
    value: function onFieldChange(e) {
      var _this2 = this;

      setTimeout(function () {
        //We have to use current target to avoid the jQuery cutoff
        _this2.setValue(_this2.input.val());
      }, 0);
    }
  }, {
    key: 'onMinusClick',
    value: function onMinusClick(e) {
      e.preventDefault();
      e.stopPropagation();
      this.setValue(this.getValue() - 1);
      this.onQuantiyMinus();
    }
  }, {
    key: 'onPlusClick',
    value: function onPlusClick(e) {
      e.preventDefault();
      e.stopPropagation();

      this.setValue(this.getValue() + 1);
      this.onQuantityPlus();
    }
  }, {
    key: 'onCartPending',
    value: function onCartPending() {
      this.plus.addClass('is-disabled');
      this.plus.attr('disabled', 'disabled');

      this.minus.addClass('is-disabled');
      this.minus.attr('disabled', 'disabled');

      this.input.addClass('is-disabled');
      this.input.attr('disabled', 'disabled');
    }
  }, {
    key: 'onCartFinished',
    value: function onCartFinished() {
      this.updateClasses();
    }
  }]);
  return QuantitySelector;
}();

var generateQuantitySelector = exports.generateQuantitySelector = function generateQuantitySelector(options) {
  options = options || {};
  var _options = options,
      clazz = _options.clazz,
      name = _options.name,
      quantity = _options.quantity,
      min = _options.min,
      max = _options.max,
      isSmall = _options.isSmall,
      styleMinus = _options.styleMinus,
      stylePlus = _options.stylePlus;


  clazz = clazz || "";
  name = name || "quantity";
  styleMinus = styleMinus || 'tertiary';
  stylePlus = stylePlus || 'tertiary';
  if ((typeof quantity === 'undefined' ? 'undefined' : (0, _typeof3.default)(quantity)) === (typeof undefined === 'undefined' ? 'undefined' : (0, _typeof3.default)(undefined))) quantity = 1;
  if ((typeof min === 'undefined' ? 'undefined' : (0, _typeof3.default)(min)) === (typeof undefined === 'undefined' ? 'undefined' : (0, _typeof3.default)(undefined))) min = null;
  if ((typeof max === 'undefined' ? 'undefined' : (0, _typeof3.default)(max)) === (typeof undefined === 'undefined' ? 'undefined' : (0, _typeof3.default)(undefined))) max = null;
  if ((typeof isSmall === 'undefined' ? 'undefined' : (0, _typeof3.default)(isSmall)) === (typeof undefined === 'undefined' ? 'undefined' : (0, _typeof3.default)(undefined))) isSmall = false;

  var minusDisabled = false;
  var plusDisabled = false;
  var inputDisabled = false;
  if (min != null && quantity <= min) minusDisabled = true;
  if (max != null && quantity >= max) plusDisabled = true;
  if (max != null && min >= max) inputDisabled = true;

  return '\n  <div\n    class="o-quantity-selector ' + clazz + ' ' + (isSmall ? 'is-small' : '') + '"\n    data-quantity-selector data-min="' + min + '" data-max="' + max + '""\n  >\n    <div class="o-quantity-selector__inner">\n      <button\n        type="button" class="\n          o-btn\n          o-quantity-selector__button is-minus\n          ' + (minusDisabled ? 'is-disabled' : '') + '\n        "\n        ' + (minusDisabled ? 'disabled' : '') + ' data-quantity-selector-minus\n      >\n        -\n      </button>\n\n      <div class="o-quantity-selector__input">\n        <input\n        type="number" class="o-input o-quantity-selector__input-field ' + (inputDisabled ? 'is-disabled' : '') + '"\n        value="' + quantity + '" data-quantity-selector-field ' + (inputDisabled ? 'disabled' : '') + '\n        name="' + name + '"\n        />\n      </div>\n\n      <button\n        type="button" class="\n          o-btn\n          o-quantity-selector__button is-plus\n          ' + (plusDisabled ? 'is-disabled' : '') + '\n        "\n        ' + (plusDisabled ? 'disabled' : '') + ' data-quantity-selector-plus\n      >\n        +\n      </button>\n    </div>\n  </div>\n\n  ';
};